import { env, apimKey } from "../../../config";
import { lang } from "../../../i18n";
import sortObjLocaleBy from "../../../utils/sortObjLocaleBy";
import log from "../../../utils/log";

export default async function fetchDistrictsAsync(cityId, serviceId) {
  log("fetchDistrictsAsync", "request", ...arguments);

  const baseUrl = `https://apim-ikeasa.azure-api.net/DistrictList/${env}/`;
  const response = await fetch(baseUrl + `${cityId}/${serviceId}`, {
    headers: {
      "Ocp-Apim-Subscription-Key": apimKey,
    },
  });

  if (response.status === 200) {
    const json = await response.json();
    log("fetchDistrictsAsync", "response", json);

    // alphabitical sort
    const prop = lang === "ar" ? "LocalizedName" : "Name";
    return json.Districts.sort(sortObjLocaleBy(prop, lang));
  }

  throw new Error(response.status);
}

/*
[
  {
    "Id": "2944",
    "Code": "10200018019",
    "Name": "Um Hableen",
    "CenterGeoPoint": "21.7124599258625,39.238041561313",
    "LocalizedName": "ام حبلين",
    "StoreNo": "407"
  },
  {
    "Id": "2932",
    "Code": "10200018007",
    "Name": "Al Ferdous",
    "CenterGeoPoint": "21.7816005392144,39.117766818291",
    "LocalizedName": "الفردوس",
    "StoreNo": "407"
  },
  {
    "Id": "2945",
    "Code": "10200018020",
    "Name": "Bryman",
    "CenterGeoPoint": "21.6462210886464,39.2454878326963",
    "LocalizedName": "بريمان",
    "StoreNo": "407"
  },
  {
    "Id": "2964",
    "Code": "10200018039",
    "Name": "Ash Shefaa",
    "CenterGeoPoint": "21.3819764586531,39.3342826948832",
    "LocalizedName": "الشفا",
    "StoreNo": "407"
  },
  {
    "Id": "2952",
    "Code": "10200018027",
    "Name": "Al Mahjar",
    "CenterGeoPoint": "21.4279286965871,39.2030244092665",
    "LocalizedName": "المحجر",
    "StoreNo": "407"
  },
  {
    "Id": "2965",
    "Code": "10200018040",
    "Name": "As Sanabel",
    "CenterGeoPoint": "21.3900155116621,39.2729201080632",
    "LocalizedName": "السنابل",
    "StoreNo": "407"
  },
  {
    "Id": "2972",
    "Code": "10200018046",
    "Name": "Al Masarah",
    "CenterGeoPoint": "21.2648103122679,39.2474057272785",
    "LocalizedName": "المسرة",
    "StoreNo": "407"
  },
  {
    "Id": "2984",
    "Code": "10200018058",
    "Name": "Al Quraiyat",
    "CenterGeoPoint": "21.4645130032621,39.1987036035485",
    "LocalizedName": "القريات",
    "StoreNo": "407"
  },
  {
    "Id": "2985",
    "Code": "10200018060",
    "Name": "Al Kandarah",
    "CenterGeoPoint": "21.4929122974213,39.2020506729262",
    "LocalizedName": "الكندرة",
    "StoreNo": "407"
  },
  {
    "Id": "2992",
    "Code": "10200018067",
    "Name": "Al Rehab",
    "CenterGeoPoint": "21.5522928247545,39.2243996729465",
    "LocalizedName": "الرحاب",
    "StoreNo": "407"
  },
  {
    "Id": "3005",
    "Code": "10200018080",
    "Name": "Al Basatin",
    "CenterGeoPoint": "21.6845865878758,39.115942196733",
    "LocalizedName": "البساتين",
    "StoreNo": "407"
  },
  {
    "Id": "3004",
    "Code": "10200018079",
    "Name": "An Naim",
    "CenterGeoPoint": "21.6280198784442,39.1435915897787",
    "LocalizedName": "النعيم",
    "StoreNo": "407"
  },
  {
    "Id": "3012",
    "Code": "10200018087",
    "Name": "King Abdul Aziz Int Airport",
    "CenterGeoPoint": "21.6936308760548,39.1655614846443",
    "LocalizedName": "مطار الملك عبدالعزيز الدولي",
    "StoreNo": "407"
  },
  {
    "Id": "3025",
    "Code": "10200018100",
    "Name": "Al Baghdadiyah Al Gharbiyah",
    "CenterGeoPoint": "21.4991423325005,39.1764987282224",
    "LocalizedName": "البغدادية الغربية",
    "StoreNo": "407"
  },
  {
    "Id": "3032",
    "Code": "10200018107",
    "Name": "As Sororyah",
    "CenterGeoPoint": "21.3915053296784,39.2122241287371",
    "LocalizedName": "السرورية",
    "StoreNo": "407"
  },
  {
    "Id": "3045",
    "Code": "10200018999",
    "Name": "Other",
    "CenterGeoPoint": "21.485662,39.192148",
    "LocalizedName": "أخرى",
    "StoreNo": "407"
  },
  {
    "Id": "2933",
    "Code": "10200018008",
    "Name": "Al Falah",
    "CenterGeoPoint": "21.7815724834379,39.1889557867242",
    "LocalizedName": "الفلاح",
    "StoreNo": "407"
  },
  {
    "Id": "2931",
    "Code": "10200018006",
    "Name": "Ash Sheraa",
    "CenterGeoPoint": "21.7650600061247,39.0945919840849",
    "LocalizedName": "الشراع",
    "StoreNo": "407"
  },
  {
    "Id": "2953",
    "Code": "10200018028",
    "Name": "An Nahdah",
    "CenterGeoPoint": "21.6198180130083,39.1269375761914",
    "LocalizedName": "النهضة",
    "StoreNo": "407"
  },
  {
    "Id": "2951",
    "Code": "10200018026",
    "Name": "Al Hindawiyah",
    "CenterGeoPoint": "21.4736300140694,39.1865539170191",
    "LocalizedName": "الهنداوية",
    "StoreNo": "407"
  },
  {
    "Id": "2973",
    "Code": "10200018049",
    "Name": "Al Wadi",
    "CenterGeoPoint": "21.3082977701055,39.1717694207282",
    "LocalizedName": "الوادي",
    "StoreNo": "407"
  },
  {
    "Id": "2971",
    "Code": "10200018047",
    "Name": "Al Moulysaa",
    "CenterGeoPoint": "21.2646069893131,39.2124747599598",
    "LocalizedName": "المليساء",
    "StoreNo": "407"
  },
  {
    "Id": "2993",
    "Code": "10200018068",
    "Name": "Al Aziziyah",
    "CenterGeoPoint": "21.553078773464,39.1943678584605",
    "LocalizedName": "العزيزية",
    "StoreNo": "407"
  },
  {
    "Id": "2991",
    "Code": "10200018066",
    "Name": "Al Faisaliyah",
    "CenterGeoPoint": "21.5720324943431,39.1834561648973",
    "LocalizedName": "الفيصلية",
    "StoreNo": "407"
  },
  {
    "Id": "3013",
    "Code": "10200018088",
    "Name": "Al Manar",
    "CenterGeoPoint": "21.6026396312699,39.2354122759905",
    "LocalizedName": "المنار",
    "StoreNo": "407"
  },
  {
    "Id": "3011",
    "Code": "10200018086",
    "Name": "Al Ajwad",
    "CenterGeoPoint": "21.6034847894209,39.2571923331748",
    "LocalizedName": "الاجواد",
    "StoreNo": "407"
  },
  {
    "Id": "3033",
    "Code": "10200018109",
    "Name": "Ash Shati",
    "CenterGeoPoint": "21.5998402225926,39.1132970535295",
    "LocalizedName": "الشاطئ",
    "StoreNo": "407"
  },
  {
    "Id": "3031",
    "Code": "10200018106",
    "Name": "Al Murjan",
    "CenterGeoPoint": "21.6866322962062,39.1001146928765",
    "LocalizedName": "المرجان",
    "StoreNo": "407"
  },
  {
    "Id": "2930",
    "Code": "10200018005",
    "Name": "Al Amwaj",
    "CenterGeoPoint": "21.7493470665042,39.073315397575",
    "LocalizedName": "الامواج",
    "StoreNo": "407"
  },
  {
    "Id": "2936",
    "Code": "10200018012",
    "Name": "Al Amir Fawaz Ash Shamaly",
    "CenterGeoPoint": "21.4357205960517,39.3010440120569",
    "LocalizedName": "الامير فواز الشمالى",
    "StoreNo": "407"
  },
  {
    "Id": "2937",
    "Code": "10200018013",
    "Name": "Ar Riyadh",
    "CenterGeoPoint": "21.8600065089224,39.1799391148828",
    "LocalizedName": "الرياض",
    "StoreNo": "407"
  },
  {
    "Id": "2950",
    "Code": "10200018025",
    "Name": "Al Adel",
    "CenterGeoPoint": "21.445136348998,39.2921838411938",
    "LocalizedName": "العدل",
    "StoreNo": "407"
  },
  {
    "Id": "2957",
    "Code": "10200018032",
    "Name": "Al Baghdadiyah Ash Sharqiyah",
    "CenterGeoPoint": "21.4990978909195,39.1919681641867",
    "LocalizedName": "البغدادية الشرقية",
    "StoreNo": "407"
  },
  {
    "Id": "2956",
    "Code": "10200018031",
    "Name": "An Nakhil",
    "CenterGeoPoint": "21.5304404025144,39.261518085264",
    "LocalizedName": "النخيل",
    "StoreNo": "407"
  },
  {
    "Id": "2970",
    "Code": "10200018045",
    "Name": "Al Barakah",
    "CenterGeoPoint": "21.2652044251118,39.2794385284438",
    "LocalizedName": "البركة",
    "StoreNo": "407"
  },
  {
    "Id": "2976",
    "Code": "10200018051",
    "Name": "At Taawon",
    "CenterGeoPoint": "21.3512286509223,39.269584998631",
    "LocalizedName": "التعاون",
    "StoreNo": "407"
  },
  {
    "Id": "2990",
    "Code": "10200018065",
    "Name": "Bani Malik",
    "CenterGeoPoint": "21.5322369977442,39.2185902790545",
    "LocalizedName": "بنى مالك",
    "StoreNo": "407"
  },
  {
    "Id": "2996",
    "Code": "10200018071",
    "Name": "Al Wahah",
    "CenterGeoPoint": "21.5565080675684,39.2443758831244",
    "LocalizedName": "الواحة",
    "StoreNo": "407"
  },
  {
    "Id": "3010",
    "Code": "10200018085",
    "Name": "As Samir",
    "CenterGeoPoint": "21.582158574291,39.2449288122189",
    "LocalizedName": "السامر",
    "StoreNo": "407"
  },
  {
    "Id": "3016",
    "Code": "10200018091",
    "Name": "Al Waziriyah",
    "CenterGeoPoint": "21.4445429643282,39.2318423593809",
    "LocalizedName": "الوزيريه",
    "StoreNo": "407"
  },
  {
    "Id": "3024",
    "Code": "10200018099",
    "Name": "King Abdul Aziz Medical City",
    "CenterGeoPoint": "21.4220744912033,39.3636074601697",
    "LocalizedName": "مدينة الملك عبدالعزيز الطبية",
    "StoreNo": "407"
  },
  {
    "Id": "3030",
    "Code": "10200018104",
    "Name": "Al Andalus",
    "CenterGeoPoint": "21.5386281155146,39.1432111830678",
    "LocalizedName": "الاندلس",
    "StoreNo": "407"
  },
  {
    "Id": "3036",
    "Code": "10200018111",
    "Name": "Az Zahra",
    "CenterGeoPoint": "21.5920299066392,39.133466926457",
    "LocalizedName": "الزهراء",
    "StoreNo": "407"
  },
  {
    "Id": "2942",
    "Code": "10200018017",
    "Name": "Al Hamadaniyah",
    "CenterGeoPoint": "21.7551185291762,39.1935594365585",
    "LocalizedName": "الحمدانية",
    "StoreNo": "407"
  },
  {
    "Id": "3044",
    "Code": "10200018119",
    "Name": "Third Industrial City",
    "CenterGeoPoint": "21.1206332620715,39.3260152268926",
    "LocalizedName": "المدينة الصناعية الثالثة",
    "StoreNo": "407"
  },
  {
    "Id": "2940",
    "Code": "10200018015",
    "Name": "Ar Rahmanyah",
    "CenterGeoPoint": "21.7928244311671,39.2166615473848",
    "LocalizedName": "الرحمانية",
    "StoreNo": "407"
  },
  {
    "Id": "2925",
    "Code": "10200018001",
    "Name": "Az Zomorod",
    "CenterGeoPoint": "21.7991708053088,39.056084863044",
    "LocalizedName": "الزمرد",
    "StoreNo": "407"
  },
  {
    "Id": "2941",
    "Code": "10200018016",
    "Name": "As Salhiyah",
    "CenterGeoPoint": "21.7635018118239,39.2234960013308",
    "LocalizedName": "الصالحية",
    "StoreNo": "407"
  },
  {
    "Id": "2935",
    "Code": "10200018010",
    "Name": "Mraykh",
    "CenterGeoPoint": "21.5367799576235,39.2974859463706",
    "LocalizedName": "مريخ",
    "StoreNo": "407"
  },
  {
    "Id": "2962",
    "Code": "10200018037",
    "Name": "Ash Sharafiyah",
    "CenterGeoPoint": "21.5171909346762,39.1869729321856",
    "LocalizedName": "الشرفية",
    "StoreNo": "407"
  },
  {
    "Id": "2960",
    "Code": "10200018035",
    "Name": "As Salamah",
    "CenterGeoPoint": "21.5939745567124,39.1515896761779",
    "LocalizedName": "السلامة",
    "StoreNo": "407"
  },
  {
    "Id": "2946",
    "Code": "10200018021",
    "Name": "Al Montazah",
    "CenterGeoPoint": "21.5951269674645,39.2798137608231",
    "LocalizedName": "المنتزة",
    "StoreNo": "407"
  },
  {
    "Id": "2955",
    "Code": "10200018030",
    "Name": "King Abdul Aziz University",
    "CenterGeoPoint": "21.4937505413853,39.2471878518811",
    "LocalizedName": "جامعة الملك عبدالعزيز",
    "StoreNo": "407"
  },
  {
    "Id": "2961",
    "Code": "10200018036",
    "Name": "Ath Thaghr",
    "CenterGeoPoint": "21.4802225001498,39.2277464289631",
    "LocalizedName": "الثغر",
    "StoreNo": "407"
  },
  {
    "Id": "2980",
    "Code": "10200018055",
    "Name": "Al Qryniah",
    "CenterGeoPoint": "21.3069433927492,39.2464754094957",
    "LocalizedName": "القرينية",
    "StoreNo": "407"
  },
  {
    "Id": "2966",
    "Code": "10200018041",
    "Name": "Al Hada",
    "CenterGeoPoint": "21.3726038264781,39.3030197171447",
    "LocalizedName": "الهدى",
    "StoreNo": "407"
  },
  {
    "Id": "2975",
    "Code": "10200018050",
    "Name": "Al Fadeylah",
    "CenterGeoPoint": "21.3069814402998,39.2784204157467",
    "LocalizedName": "الفضيلة",
    "StoreNo": "407"
  },
  {
    "Id": "2981",
    "Code": "10200018057",
    "Name": "An Nasim",
    "CenterGeoPoint": "21.5192434754528,39.2306735212241",
    "LocalizedName": "النسيم",
    "StoreNo": "407"
  },
  {
    "Id": "2986",
    "Code": "10200018061",
    "Name": "Al Ammariyah",
    "CenterGeoPoint": "21.4920866169752,39.1931057785625",
    "LocalizedName": "العمارية",
    "StoreNo": "407"
  },
  {
    "Id": "3000",
    "Code": "10200018075",
    "Name": "Al Bashaer",
    "CenterGeoPoint": "21.8043190809502,39.1745319314832",
    "LocalizedName": "البشائر",
    "StoreNo": "407"
  },
  {
    "Id": "2995",
    "Code": "10200018070",
    "Name": "Al Wurud",
    "CenterGeoPoint": "21.518624443484,39.2031594698275",
    "LocalizedName": "الورود",
    "StoreNo": "407"
  },
  {
    "Id": "3001",
    "Code": "10200018076",
    "Name": "Al Muhammadiyah",
    "CenterGeoPoint": "21.6494853198729,39.123464900436",
    "LocalizedName": "المحمدية",
    "StoreNo": "407"
  },
  {
    "Id": "3006",
    "Code": "10200018081",
    "Name": "Ar Rabwah",
    "CenterGeoPoint": "21.6014204823091,39.1818609135655",
    "LocalizedName": "الربوة",
    "StoreNo": "407"
  },
  {
    "Id": "3020",
    "Code": "10200018095",
    "Name": "Al Jamiah",
    "CenterGeoPoint": "21.4747540015086,39.251747287875",
    "LocalizedName": "الجامعة",
    "StoreNo": "407"
  },
  {
    "Id": "3026",
    "Code": "10200018102",
    "Name": "Ar Ruwais",
    "CenterGeoPoint": "21.515366876119,39.1711326843226",
    "LocalizedName": "الرويس",
    "StoreNo": "407"
  },
  {
    "Id": "3040",
    "Code": "10200018115",
    "Name": "Jeddah Eslamic Seaport",
    "CenterGeoPoint": "21.4696072663556,39.1665696452203",
    "LocalizedName": "ميناء جدة الاسلامى",
    "StoreNo": "407"
  },
  {
    "Id": "2938",
    "Code": "10200018011",
    "Name": "Ash Shrouk",
    "CenterGeoPoint": "21.5639229275622,39.2771984189354",
    "LocalizedName": "الشروق",
    "StoreNo": "407"
  },
  {
    "Id": "2929",
    "Code": "10200018004",
    "Name": "As Swaryee",
    "CenterGeoPoint": "21.7997932915684,39.1007410920801",
    "LocalizedName": "الصوارى",
    "StoreNo": "407"
  },
  {
    "Id": "2934",
    "Code": "10200018009",
    "Name": "Al Asalah",
    "CenterGeoPoint": "21.7785951972504,39.1552272375881",
    "LocalizedName": "الاصالة",
    "StoreNo": "407"
  },
  {
    "Id": "2958",
    "Code": "10200018033",
    "Name": "An Nazlah Ash Sharqiyah",
    "CenterGeoPoint": "21.4730335375218,39.2203327038132",
    "LocalizedName": "النزلة الشرقية",
    "StoreNo": "407"
  },
  {
    "Id": "2949",
    "Code": "10200018024",
    "Name": "Al Farouk",
    "CenterGeoPoint": "21.4511297174986,39.2689800237665",
    "LocalizedName": "الفاروق",
    "StoreNo": "407"
  },
  {
    "Id": "2978",
    "Code": "10200018053",
    "Name": "Al Khomrah",
    "CenterGeoPoint": "21.3526702578499,39.2453937408755",
    "LocalizedName": "الخمرة",
    "StoreNo": "407"
  },
  {
    "Id": "2969",
    "Code": "10200018044",
    "Name": "Ar Rahmah",
    "CenterGeoPoint": "21.2669068746875,39.3082477497123",
    "LocalizedName": "الرحمة",
    "StoreNo": "407"
  },
  {
    "Id": "2977",
    "Code": "10200018052",
    "Name": "As Sarawat",
    "CenterGeoPoint": "21.3509866743039,39.2126922501462",
    "LocalizedName": "السروات",
    "StoreNo": "407"
  },
  {
    "Id": "2982",
    "Code": "10200018056",
    "Name": "An Nazlah Al Yamaniyah",
    "CenterGeoPoint": "21.469223454903,39.2100142676191",
    "LocalizedName": "النزلة اليمانية",
    "StoreNo": "407"
  },
  {
    "Id": "2989",
    "Code": "10200018064",
    "Name": "Ar Rawdah",
    "CenterGeoPoint": "21.5642568316371,39.1561548923714",
    "LocalizedName": "الروضة",
    "StoreNo": "407"
  },
  {
    "Id": "2998",
    "Code": "10200018073",
    "Name": "As Sulaymaniyah",
    "CenterGeoPoint": "21.5064328086158,39.2481778802731",
    "LocalizedName": "السليمانية",
    "StoreNo": "407"
  },
  {
    "Id": "3002",
    "Code": "10200018077",
    "Name": "Al Kawthar",
    "CenterGeoPoint": "21.7269581517076,39.2066964410648",
    "LocalizedName": "الكوثر",
    "StoreNo": "407"
  },
  {
    "Id": "2997",
    "Code": "10200018072",
    "Name": "Abruq Ar Rughamah",
    "CenterGeoPoint": "21.5018377916613,39.2879952164881",
    "LocalizedName": "ابرق الرغامة",
    "StoreNo": "407"
  },
  {
    "Id": "3009",
    "Code": "10200018084",
    "Name": "Al Marwah",
    "CenterGeoPoint": "21.61864868905,39.2011070645348",
    "LocalizedName": "المروة",
    "StoreNo": "407"
  },
  {
    "Id": "3015",
    "Code": "10200018090",
    "Name": "Al Amir Abdoulmajed",
    "CenterGeoPoint": "21.4212274805266,39.2737992809379",
    "LocalizedName": "الامير عبدالمجيد",
    "StoreNo": "407"
  },
  {
    "Id": "3022",
    "Code": "10200018097",
    "Name": "Al Fadel",
    "CenterGeoPoint": "21.4336677178289,39.3267678287265",
    "LocalizedName": "الفضل",
    "StoreNo": "407"
  },
  {
    "Id": "3018",
    "Code": "10200018093",
    "Name": "Al Amir Fawaz Al Janouby",
    "CenterGeoPoint": "21.4311283021384,39.2927792215279",
    "LocalizedName": "الامير فواز الجنوبى",
    "StoreNo": "407"
  },
  {
    "Id": "3017",
    "Code": "10200018092",
    "Name": "Al Jawharah",
    "CenterGeoPoint": "21.4319846690575,39.2513370494866",
    "LocalizedName": "الجوهرة",
    "StoreNo": "407"
  },
  {
    "Id": "3029",
    "Code": "10200018105",
    "Name": "Abhur Al Janubiyah",
    "CenterGeoPoint": "21.7354934911834,39.1304009150986",
    "LocalizedName": "ابحر الجنوبية",
    "StoreNo": "407"
  },
  {
    "Id": "3021",
    "Code": "10200018096",
    "Name": "Ar Rawabi",
    "CenterGeoPoint": "21.4702649967328,39.2679505694233",
    "LocalizedName": "الروابي",
    "StoreNo": "407"
  },
  {
    "Id": "3035",
    "Code": "10200018110",
    "Name": "Madain Al Fahd",
    "CenterGeoPoint": "21.4597703239166,39.2384403803596",
    "LocalizedName": "مدائن الفهد",
    "StoreNo": "407"
  },
  {
    "Id": "3042",
    "Code": "10200018117",
    "Name": "Al Harazat Dist",
    "CenterGeoPoint": "21.491435788704,39.3687058367116",
    "LocalizedName": "حي الحرازات",
    "StoreNo": "407"
  },
  {
    "Id": "3038",
    "Code": "10200018113",
    "Name": "Al Faiha",
    "CenterGeoPoint": "21.4998907343216,39.2178380088315",
    "LocalizedName": "الفيحاء",
    "StoreNo": "407"
  },
  {
    "Id": "3037",
    "Code": "10200018112",
    "Name": "Al Hamra",
    "CenterGeoPoint": "21.5276194290346,39.1638569912337",
    "LocalizedName": "الحمراء",
    "StoreNo": "407"
  },
  {
    "Id": "3041",
    "Code": "10200018116",
    "Name": "Al Wafa Dist",
    "CenterGeoPoint": "21.8431346816833,39.234690242858",
    "LocalizedName": "حي الوفاء",
    "StoreNo": "407"
  },
  {
    "Id": "2943",
    "Code": "10200018018",
    "Name": "Ar Rayaan",
    "CenterGeoPoint": "21.6856799389948,39.2095079045215",
    "LocalizedName": "الريان",
    "StoreNo": "407"
  },
  {
    "Id": "2927",
    "Code": "10200018002",
    "Name": "Al Loaloa",
    "CenterGeoPoint": "21.7672676124362,39.0610398095582",
    "LocalizedName": "اللؤلؤ",
    "StoreNo": "407"
  },
  {
    "Id": "2963",
    "Code": "10200018038",
    "Name": "King Faisal Naval Base",
    "CenterGeoPoint": "21.3591342507103,39.173480118485",
    "LocalizedName": "قاعدة الملك فيصل البحرية",
    "StoreNo": "407"
  },
  {
    "Id": "2947",
    "Code": "10200018023",
    "Name": "Al Balad",
    "CenterGeoPoint": "21.4830278802907,39.1867183074219",
    "LocalizedName": "البلد",
    "StoreNo": "407"
  },
  {
    "Id": "2983",
    "Code": "10200018059",
    "Name": "Ghulail",
    "CenterGeoPoint": "21.4532773286518,39.2051102156372",
    "LocalizedName": "غليل",
    "StoreNo": "407"
  },
  {
    "Id": "2967",
    "Code": "10200018042",
    "Name": "At Tadamon",
    "CenterGeoPoint": "21.3410002686605,39.3044892927943",
    "LocalizedName": "التضامن",
    "StoreNo": "407"
  },
  {
    "Id": "3003",
    "Code": "10200018078",
    "Name": "Taibah",
    "CenterGeoPoint": "21.8048685118649,39.139343819377",
    "LocalizedName": "طيبة",
    "StoreNo": "407"
  },
  {
    "Id": "2987",
    "Code": "10200018062",
    "Name": "As Sahifah",
    "CenterGeoPoint": "21.4876919854079,39.1953619276571",
    "LocalizedName": "الصحيفة",
    "StoreNo": "407"
  },
  {
    "Id": "3023",
    "Code": "10200018098",
    "Name": "Um Asalam",
    "CenterGeoPoint": "21.4555030024394,39.345864082845",
    "LocalizedName": "ام السلم",
    "StoreNo": "407"
  },
  {
    "Id": "3007",
    "Code": "10200018082",
    "Name": "An Nuzhah",
    "CenterGeoPoint": "21.6253663011391,39.1666401088006",
    "LocalizedName": "النزهة",
    "StoreNo": "407"
  },
  {
    "Id": "3043",
    "Code": "10200018118",
    "Name": "Al Mahamid Dist",
    "CenterGeoPoint": "21.4505661730799,39.3980734806654",
    "LocalizedName": "حي المحاميد",
    "StoreNo": "407"
  },
  {
    "Id": "3027",
    "Code": "10200018101",
    "Name": "Abhur Ash Shamaliyah",
    "CenterGeoPoint": "21.7449862799291,39.1045850669009",
    "LocalizedName": "ابحر الشمالية",
    "StoreNo": "407"
  },
  {
    "Id": "2928",
    "Code": "10200018003",
    "Name": "Al Yaqoot",
    "CenterGeoPoint": "21.7831518978085,39.0795291002573",
    "LocalizedName": "الياقوت",
    "StoreNo": "407"
  },
  {
    "Id": "2954",
    "Code": "10200018029",
    "Name": "Al Khalidiyah",
    "CenterGeoPoint": "21.5604272731665,39.1342158815598",
    "LocalizedName": "الخالدية",
    "StoreNo": "407"
  },
  {
    "Id": "2948",
    "Code": "10200018022",
    "Name": "Ath Thaalibah",
    "CenterGeoPoint": "21.4645965773326,39.1858646075276",
    "LocalizedName": "الثعالبة",
    "StoreNo": "407"
  },
  {
    "Id": "2974",
    "Code": "10200018048",
    "Name": "Al Qouzeen",
    "CenterGeoPoint": "21.2627960862412,39.1700486184117",
    "LocalizedName": "القوزين",
    "StoreNo": "407"
  },
  {
    "Id": "2968",
    "Code": "10200018043",
    "Name": "Al Karamah",
    "CenterGeoPoint": "21.3044539094277,39.3123608875024",
    "LocalizedName": "الكرامة",
    "StoreNo": "407"
  },
  {
    "Id": "2988",
    "Code": "10200018063",
    "Name": "As Sabil",
    "CenterGeoPoint": "21.4808314597072,39.2012353527909",
    "LocalizedName": "السبيل",
    "StoreNo": "407"
  },
  {
    "Id": "3008",
    "Code": "10200018083",
    "Name": "As Safa",
    "CenterGeoPoint": "21.5849673400037,39.2121801899068",
    "LocalizedName": "الصفا",
    "StoreNo": "407"
  },
  {
    "Id": "3028",
    "Code": "10200018103",
    "Name": "Petromin",
    "CenterGeoPoint": "21.4459152154737,39.1827618473826",
    "LocalizedName": "بترومين",
    "StoreNo": "407"
  },
  {
    "Id": "2994",
    "Code": "10200018069",
    "Name": "Mishrifah",
    "CenterGeoPoint": "21.5394113954549,39.1969998020665",
    "LocalizedName": "مشرفة",
    "StoreNo": "407"
  },
  {
    "Id": "3014",
    "Code": "10200018089",
    "Name": "Industrial Area",
    "CenterGeoPoint": "21.4000670222306,39.2385276797543",
    "LocalizedName": "المنطقة الصناعية",
    "StoreNo": "407"
  },
  {
    "Id": "2939",
    "Code": "10200018014",
    "Name": "Al Frosyah",
    "CenterGeoPoint": "21.8252114290846,39.205522315185",
    "LocalizedName": "الفروسية",
    "StoreNo": "407"
  },
  {
    "Id": "3034",
    "Code": "10200018108",
    "Name": "Al Ajaweed",
    "CenterGeoPoint": "21.4030231879873,39.3098923363922",
    "LocalizedName": "الاجاويد",
    "StoreNo": "407"
  },
  {
    "Id": "2959",
    "Code": "10200018034",
    "Name": "Al Bawadi",
    "CenterGeoPoint": "21.5989141681331,39.1656868835651",
    "LocalizedName": "البوادي",
    "StoreNo": "407"
  },
  {
    "Id": "2979",
    "Code": "10200018054",
    "Name": "Ad Dahiah",
    "CenterGeoPoint": "21.307360182611,39.2112740950127",
    "LocalizedName": "الضاحية",
    "StoreNo": "407"
  },
  {
    "Id": "2999",
    "Code": "10200018074",
    "Name": "As Sahil",
    "CenterGeoPoint": "21.299414479676,39.1319733737276",
    "LocalizedName": "الساحل",
    "StoreNo": "407"
  },
  {
    "Id": "3019",
    "Code": "10200018094",
    "Name": "Al Mutanazahat",
    "CenterGeoPoint": "21.468683580239,39.2901957794546",
    "LocalizedName": "المتنزهات",
    "StoreNo": "407"
  },
  {
    "Id": "3039",
    "Code": "10200018114",
    "Name": "Bahrah",
    "CenterGeoPoint": "21.4104604749936,39.4634089479979",
    "LocalizedName": "بحرة",
    "StoreNo": "407"
  }
]

*/
